import { CustomProductFormActions } from '../reducer';

export function deleteRow(dispatch, data) {
  return (key) => {
    const dataSource = [...data];
    dispatch({ type: CustomProductFormActions.SET_FORM_VALUE, payload: dataSource.filter(item => item.key !== key) });
  };
}
